import { createAsyncThunk, createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../app/appTypes"
import { getWithAuth } from "../../http"
import { signTestRun } from "./documentTests/documentTestsApi"

export interface Signature {
    id: string
    sign: string
}

const adapter = createEntityAdapter<Signature>({
    selectId: c => c.id,
})

export type SignaturesState = EntityState<Signature>

export const loadSignature = createAsyncThunk<Signature, string, AppThunkAPIType>('signatures/load', async (signId, api) => {
    const { dispatch, rejectWithValue } = api
    const result = await dispatch(getWithAuth({ url: `api/signatures/${signId}`}))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as Signature
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const signaturesSlice = createSlice({
    name: 'signatures',
    initialState: adapter.getInitialState(),
    reducers: {},
    extraReducers: builder => {
        builder.addCase(loadSignature.fulfilled, (state, action) => {
            adapter.addOne(state, action.payload)
        })
        builder.addCase(signTestRun.fulfilled, (state, action) => {
            const { signatureId, sign } = action.payload
            adapter.addOne(state, {
                id: signatureId,
                sign,
            })
        })
    }
})

export const { selectById: selectSignById } = adapter.getSelectors()

export default signaturesSlice.reducer
